export class ResetPassword {
  public tmpUUID: string;
  public loginId: string;
	public password: string;
}
